/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ until: NonNullable<unknown> }} Actionrunsuntil2Inputs */

const en_actionrunsuntil2 = /** @type {(inputs: Actionrunsuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Valid until ${i?.until}`)
};

const de_actionrunsuntil2 = /** @type {(inputs: Actionrunsuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gilt bis ${i?.until}`)
};

/**
* | output |
* | --- |
* | "Valid until {until}" |
*
* @param {Actionrunsuntil2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionrunsuntil2 = /** @type {((inputs: Actionrunsuntil2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionrunsuntil2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionrunsuntil2(inputs)
	return de_actionrunsuntil2(inputs)
});
export { actionrunsuntil2 as "actionRunsUntil" }